module.exports = __webpack_public_path__ + "img/Garuda-logo.2194d7fa.png";